import { useEnvironmentStore } from "../stores/environment.store";
import { useProfileStore } from "../stores/profile.store";
import { CookieFacade } from "./cookie.facade";
import { RouteFacade } from "./route.facade";
import { ToastFacade } from "./toast.facade";
import { TokenFacade } from "./token.facade";

export function useFacade() {
    const cookie = new CookieFacade();
    const profileStore = useProfileStore();

    return {
        cookie: cookie,
        token: new TokenFacade(cookie),
        route: new RouteFacade(),
        profile: profileStore.data!,
        isTesting: import.meta.env.MODE !== "production",
        env: useEnvironmentStore(),
        createURL: (suffix: string) => {
            if (import.meta.env.SSR) return suffix;
            return `${window.location.protocol}//${window.location.host}${suffix}`;
        },
    };
}

export function useToastFacade() {
    return new ToastFacade();
}
